module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-backplates-remnants.797da6ef.png";